import {create} from "zustand/index";

export const useLocationStore = create((set, get) => ({
    // Модальное окно "Выбор города"
    selectCityFlag: false,

    /**
     * Модальное окно "Выбор города"
     */
    openModalSelectCity: () => set({selectCityFlag: true}),

    /**
     * Модальное окно "Выбор города"
     */
    closeModalSelectCity: () => set({selectCityFlag: false}),
}));
